import { render, staticRenderFns } from "./safeCheckActivityResUp.vue?vue&type=template&id=54e545e5&scoped=true"
import script from "./safeCheckActivityResUp.vue?vue&type=script&lang=js"
export * from "./safeCheckActivityResUp.vue?vue&type=script&lang=js"
import style0 from "./safeCheckActivityResUp.vue?vue&type=style&index=0&id=54e545e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e545e5",
  null
  
)

export default component.exports